module.exports = __webpack_public_path__ + "img/vehicle-options-white-nissan.41984693.png";